export default __webpack_public_path__ + "static/media/full_white.4bf16fc7.png";